import React from 'react';
import classNames from 'classnames';

import css from './IconPeople.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconPeople = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M29.2167 12.95C29.1001 12.9334 28.9834 12.9334 28.8667 12.95C26.2834 12.8667 24.2334 10.75 24.2334 8.15004C24.2334 5.50004 26.3834 3.33337 29.0501 3.33337C31.7001 3.33337 33.8667 5.48337 33.8667 8.15004C33.8501 10.75 31.8001 12.8667 29.2167 12.95Z"
        fill="#A9DBFB"
      />
      <path
        d="M34.6503 24.4999C32.7837 25.7499 30.167 26.2166 27.7503 25.8999C28.3837 24.5333 28.717 23.0166 28.7337 21.4166C28.7337 19.7499 28.367 18.1666 27.667 16.7833C30.1337 16.4499 32.7503 16.9166 34.6337 18.1666C37.267 19.8999 37.267 22.7499 34.6503 24.4999Z"
        fill="#A9DBFB"
      />
      <path
        d="M10.7329 12.95C10.8496 12.9334 10.9663 12.9334 11.0829 12.95C13.6663 12.8667 15.7163 10.75 15.7163 8.15004C15.7163 5.48337 13.5663 3.33337 10.8996 3.33337C8.24961 3.33337 6.09961 5.48337 6.09961 8.15004C6.09961 10.75 8.14961 12.8667 10.7329 12.95Z"
        fill="#A9DBFB"
      />
      <path
        d="M10.9169 21.4167C10.9169 23.0333 11.2669 24.5667 11.9002 25.95C9.5502 26.2 7.1002 25.7 5.3002 24.5167C2.66686 22.7667 2.66686 19.9167 5.3002 18.1667C7.08353 16.9667 9.60019 16.4833 11.9669 16.75C11.2835 18.15 10.9169 19.7333 10.9169 21.4167Z"
        fill="#A9DBFB"
      />
      <path
        d="M20.2 26.45C20.0667 26.4333 19.9167 26.4333 19.7667 26.45C16.7 26.35 14.25 23.8333 14.25 20.7333C14.2667 17.5667 16.8167 15 20 15C23.1667 15 25.7333 17.5667 25.7333 20.7333C25.7167 23.8333 23.2833 26.35 20.2 26.45Z"
        fill="#A9DBFB"
      />
      <path
        d="M14.783 29.9C12.2663 31.5834 12.2663 34.35 14.783 36.0167C17.6497 37.9334 22.3497 37.9334 25.2163 36.0167C27.733 34.3334 27.733 31.5667 25.2163 29.9C22.3663 27.9834 17.6663 27.9834 14.783 29.9Z"
        fill="#A9DBFB"
      />
    </svg>
  );
};

export default IconPeople;
